import {assert} from 'Asserts';
import {Container, GridCellSummary} from 'constants/SampleConstants';
import {getStorableBarcode} from 'inventory/storableUtil';
import {Cell} from 'notebook/tables/TableConstants';
import {getTypedValueFromStorableSummaries} from 'notebook/tables/typed-values/DataTypes';
import {BaseTypedValueType} from 'notebook/tables/typed-values/TypedValueConstants';
import {StorableInfo} from 'notebook/tables/typed-values/TypedValueTypes';
import {PreparedSample} from 'workflows/samples/PreparedSampleGroupConstants';

import {StorableSummaryGraphQL} from '../../graphql-fragments/inventory/__generated/StorableSummaryGraphQL';

export function getSampleGroupSampleTableCell(sample: PreparedSample | null): Cell {
  if (sample == null) {
    return {text: '', locked: true};
  }
  return {
    text: '',
    typedValue: {
      type: BaseTypedValueType.STAGE_RUN_SAMPLE,
      // @ts-expect-error
      stageRunSample: {
        ...sample,
        id: sample.id!,
        containerId: null,
      },
    },
    locked: true,
  };
}

/**
 * This method generates a table cell for a storable. As such, it knows how to handle
 * several situations:
 *
 * If you have a full object (StorableSummary or Container), pass it in. It will be
 * rendered as a chip in the table.
 *
 * If you only have the id, that means the storable is inaccessible. It will be rendered
 * as "(No Access)" or the like.
 *
 * If you have nothing (i.e., there are no storables in this cell), pass null, and the
 * cell will be empty.
 *
 */
export function getStorableTableCell(
  storable: StorableSummaryGraphQL | Container | null,
  storableId?: string | null
): Cell {
  let storableSummaries: Array<StorableInfo>;

  if (storable == null) {
    if (storableId != null) {
      assert(storableId.length > 0, 'You must pass a valid inaccessible storableId');
      // Inaccessible. (The StorableChip will look in the Redux store "inaccessibleStorableIds"
      // to determine this.)
      storableSummaries = [{id: storableId, name: ''}];
    } else {
      // No storable at all
      storableSummaries = [];
    }
  } else {
    // A normal storable with known data
    storableSummaries = [{id: storable.id, name: storable.name, barcode: getStorableBarcode(storable)}];
  }

  return {
    text: '',
    typedValue: getTypedValueFromStorableSummaries(storableSummaries),
    locked: true,
  };
}

export function getGridPositionTableCell(gridCell: GridCellSummary | null): Cell {
  if (gridCell == null) {
    return {text: '', locked: true};
  }
  return {
    text: '',
    typedValue: {
      type: BaseTypedValueType.GRID_COORDINATES,
      gridCoordinates: gridCell,
    },
    locked: true,
  };
}
